import type { QueryKey } from "@tanstack/react-query";

/**
 * Query keys for an evidence item's files (the evidence item Files tab). Own
 * namespace, separate from `evidencePhotosQueryKeys`: the item's folder comes
 * from the Files API, the photo list from the evidence photo routes.
 */
export const evidenceFilesQueryKeys = {
  all: ["evidence-files"] as QueryKey,
  // The item's folder in Case Files (null until its first upload).
  itemFolder: (evidenceId?: number): QueryKey => [
    "evidence-files",
    "item-folder",
    { evidence_id: evidenceId },
  ],
};
